import CEO from "../Assets/CEO.png";
import Teja from "../Assets/Teja.jpeg";

const teamDetails = [
  {
    img: CEO,
    name: "Cherukuri Rajesh",
    designation: "Founder",
    linkedLink: "https://www.linkedin.com/in/cherukuri-rajesh-37286728/",
  },
  {
    img: Teja,
    name: "Teja Pothula",
    designation: "Director of Operations",
    linkedLink: "https://www.linkedin.com/in/teja-pothula-634141168/",
  },
];

export default teamDetails;